import * as React from 'react';
import { AuthContext } from '../../AuthContext';
import { TRight } from '../../config/Config';

interface IProps {
  children?: React.ReactNode;
  right: TRight;
}

const Gate = (props: IProps): JSX.Element => {
  const auth = React.useContext(AuthContext);
  if(auth && auth.hasRight(props.right)) return <>{props.children}</>;
  return null;
}

export { Gate }
